import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import './RentOutIntentStep.scss'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Button } from '../../components/styled/Button/Button'
import { Intent } from '../../@types/intent'
import { reportTrackingEvent } from '../../tracking/thunks'
import { useReportViewEvent } from '../../hooks'
import { updateIntent } from '../../store/lead/leadSlice'
import { StepProps } from '../../@types/step'
import { Illustration, IntegrationType, Theme } from '../../@types/config'
import { ReduxState } from '../../store/reducers'
import { SellWithRealtorStepIcon } from '../../components/icons/StepIcons/SellWithRealtorStepIcon'
import { BlueHighlighterIcon } from '../../components/icons/BlueHighlighterIcon'
import { getCustomDimensionForIntent } from '../../tracking/tracking'

export const rentOutRealtorOptionButtons = {
  [Intent.MAKLER_LET]: 'Ja',
  [Intent.MAYBE_MAKLER_LET]: 'Vielleicht',
  [Intent.INDEPENDENT_LET]: 'Nein',
}

export const PAGE_TITLE = 'letwithrealtor'

const Headline: React.JSX.Element = (
  <>
    <span className='font-l'>Optimal vermieten mit professioneller Unterstützung</span>
    <span>
      <br />
      Kommt ein Makler für dich in Frage?
    </span>
  </>
)

const RentOutIntentStep = (props: StepProps) => {
  useReportViewEvent({ pageTitle: PAGE_TITLE })
  const theme: Theme = useSelector((state: ReduxState) => state.config.theme)
  const illustration: Illustration = useSelector((state: ReduxState) => state.config.illustration)
  const integrationType = useSelector((state: ReduxState) => state.config.integrationType)
  const isIv24Integration = integrationType === IntegrationType.IMMOVERKAUF24

  const dispatch = useDispatch()

  const goToNextStep = (intent: Intent) => {
    dispatch(updateIntent(intent))
    dispatch(
      reportTrackingEvent({
        pageTitle: PAGE_TITLE,
        category: 'residential',
        action: 'realtor-leadengine',
        label: 'letwithrealtor_submit',
        inputValue: getCustomDimensionForIntent(intent),
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: getCustomDimensionForIntent(intent),
        },
      })
    )
    if (props.goToNextStep) props.goToNextStep()
  }

  return (
    <StepTemplate
      icon={<SellWithRealtorStepIcon />}
      headline={Headline}
      displayNext={false}
      goToPreviousStep={props.goToPreviousStep}
      progress={props.progress}
      displayBack={props.displayBack}
      className='rent-out-intent-content'
      backgroundColor={theme.background}
      textColor={theme.text}
      illus={illustration}
    >
      <section className='rent-out-intent-holder'>
        <section className='rent-out-intent-options'>
          {Object.entries(rentOutRealtorOptionButtons).map(([intent, label]) => (
            <Button
              key={intent}
              onClick={() => goToNextStep(intent as Intent)}
              className='margin-right-l margin-bottom-xl'
              text={label}
              backgroundColor={`${
                isIv24Integration ? theme?.secondary : theme.background !== `` ? theme.background : null
              }`}
              color={isIv24Integration ? '#FFFFFF' : theme.text}
              borderColor={theme?.secondary}
            />
          ))}
        </section>
        <section className='rent-out-intent-info'>
          <figure className='icon-with-caption'>
            <div className='icons' aria-label='advertising icon'>
              <BlueHighlighterIcon className='icons-container blue-bg' />
              <i className='font-m is24-icon-advertising' aria-hidden={true} />
            </div>
            <figcaption className='rle-primary-text'>Vorteile mit Makler</figcaption>
          </figure>
          <ul className='list-check'>
            <li>Passenden Mieter finden</li>
            <li>Optimale Miete erzielen</li>
            <li>Individuelle Beratung</li>
          </ul>
        </section>
      </section>
    </StepTemplate>
  )
}

export default RentOutIntentStep
